import moment from 'moment';

import { Utils, ReviewParadigm, PermitMap } from '@mvrb-frontend/shared-ui';
import { Permits, ReviewStatusEnum } from '../constants';
export default class ReviewModel {
  id: string;
  type: string;
  boardId: string;
  organizationId: string;
  proponentUserIds: string[];
  name: string;
  title: string;
  fileNumber: string;
  registryUrl: string;
  permit: string[] | { value: string; label: string }[] = Permits;
  documents = [];
  activityId: string;
  description: string;
  reviewParadigm: string[] | { value: string; label: string }[] = ReviewParadigm;
  responseDueAt?: string;
  timelineStartDate?: string;
  submissionReceivedDate?: string;
  commentDueAt?: string;
  completedAt?: string;
  staffMemberIds: string[];
  deletedStaffUsers: string[];
  primaryContactId: string;
  relatedReviewIds: string[];
  distributionListId: string;
  distributionUserIds: { value: string; label: string }[];
  distributionListIds: { value: string; label: string }[];
  totalListRecipients: number;
  phase: number;
  registryNumber: number;
  checkboxFilters: any;
  newEdit: any[];
  newEditDate: any;
  // Related Public Reviews
  publicReviews = '';
  status = ReviewStatusEnum.DRAFT;

  // Location
  location: any;

  // Additional File Numbers
  additionalFileNumbers: { id: string; fileNumber: string; registryUrl: string }[];

  //Edited history - Documents changes tracking
  editedDocument: false;

  constructor(data: any = {}) {
    this.id = data.id || undefined;
    this.type = data.type;
    this.boardId = data.board ? data.board.id : '';
    this.organizationId = data.organization ? data.organization.id : '';
    this.proponentUserIds =
      data.proponentUsers && data.proponentUsers.length > 0
        ? data.proponentUsers.map(p => ({ value: p.id, label: p.displayName }))
        : [];
    this.name = data.name || '';
    this.title = data.title || '';
    this.fileNumber = data.fileNumber || '';
    this.registryUrl = data.registryUrl || '';
    this.permit = data.permit ? data.permit.map(p => ({ value: p, label: PermitMap[p] })) : [];
    this.activityId = data.activities?.length > 0 ? data.activities[0].id : '';
    this.description = data.description || '';
    this.reviewParadigm = data.reviewParadigm
      ? data.reviewParadigm.map(el => ({
          value: el,
          label: ReviewParadigm.find(paradigm => paradigm.value === el)?.label,
        }))
      : [];
    this.commentDueAt = data.commentDueAt ? moment.unix(data.commentDueAt).toISOString() : undefined;
    this.responseDueAt = data.responseDueAt ? moment.unix(data.responseDueAt).toISOString() : undefined;
    this.timelineStartDate = data.timelineStartDate ? moment.unix(data.timelineStartDate).toISOString() : undefined;
    this.completedAt = data.completedAt ? moment.unix(data.completedAt).toISOString() : undefined;
    this.submissionReceivedDate = data.submissionReceivedDate
      ? moment.unix(data.submissionReceivedDate).toISOString()
      : undefined;
    this.staffMemberIds =
      data.staffMembers?.length > 0 ? data.staffMembers.map(s => ({ value: s.id, label: s.displayName })) : [];

    this.deletedStaffUsers = (data.staffMembers || []).filter(u => u.deletedDate);

    this.relatedReviewIds = data.relateds?.length > 0 ? data.relateds.map(r => ({ value: r.id, label: r.title })) : [];
    this.primaryContactId = data.primaryContact ? data.primaryContact.id : '';
    this.documents = data.documents?.length > 0 ? data.documents.map(doc => doc) : [];
    this.status = data.status || ReviewStatusEnum.DRAFT;
    this.location = Utils.isJsonString(data.location)
      ? JSON.parse(data.location)
      : { latitude: undefined, longitude: undefined, latlng: '' };
    this.phase = data.phase;
    this.registryNumber = data.registryNumber;

    this.distributionListId = data.distributionList?.id || undefined;
    this.distributionListIds = Array.isArray(data.distributionList?.children)
      ? data.distributionList.children.map(el => ({ value: el.id, label: el.name }))
      : [];
    this.distributionUserIds = Array.isArray(data.distributionList?.users)
      ? data.distributionList.users.map(el => ({ value: el.id, label: el.displayName }))
      : [];
    this.totalListRecipients = data.distributionList?.userCount || 0;

    this.additionalFileNumbers = data.additionalFileNumbers || [];
    this.newEdit = data.newEdit ? data.newEdit : undefined;
    this.newEditDate = data.newEditDate ? data.newEditDate : undefined;
    this.editedDocument = data?.editedDocument || false;
    this.checkboxFilters = data?.checkboxFilters
      ? {
          deemed: data.checkboxFilters.includes('deemed'),
          referred: data.checkboxFilters.includes('referred'),
          ssTimelines: data.checkboxFilters.includes('ssTimelines'),
        }
      : {
          deemed: false,
          referred: false,
          ssTimelines: false,
        };
  }
}
